export default __webpack_public_path__ + "static/media/NwadiutoOkereke.5199e62f.svg";